/* eslint-disable no-underscore-dangle */

import React from 'react'

export type LanguageCellProps = {
  cellProps: any
}

export const languageFilter = (filterItem: any, data: any) => {
  const filter = filterItem.value.toLowerCase()
  const { language } = data._original
  let result = false
  if (language && language.name && language.name.toLowerCase().includes(filter))
    result = true
  return result
}

export const LanguageCell = (props: LanguageCellProps) => {
  const { cellProps } = props

  const { language } = cellProps.original
  if (language && language.name) {
    return <span>{language.name}</span>
  }
  return null
}
